import { Middleware, Dispatch } from 'redux';
import { IApplicationState } from './applicationState';
import { logEvent } from '../services/log';
import { logNetworkVisit } from '../services/person'

let switchedToGroup: string | undefined;

const groupChangeLoggingMiddleware: Middleware<{}, IApplicationState> = api => (next: Dispatch) => action => {
    const previousState = api.getState();
    const result = next(action);
    const resultState = api.getState();

    if (resultState.groupData.currentGroup && resultState.groupData.currentGroup !== previousState.groupData.currentGroup) {
        switchedToGroup = resultState.groupData.currentGroup;
    }

    const group = switchedToGroup ? resultState.groupData.groups.groups.byId[switchedToGroup] : undefined;
    const urlGroupMatch = window.location.href.match(/\/Group\/(\w+)/i);

    if (group && urlGroupMatch && (group.alias === urlGroupMatch[1] || group.id === urlGroupMatch[1]) && resultState.oidc.user && resultState.oidc.user.profile && resultState.oidc.user.profile.role && resultState.oidc.user.profile.role !== 'DI') {
        const cookie = readCookie();
        
        let visited = JSON.parse(cookie.networksvisited || '[]');
        if (!visited.includes(group.id)) {
            logEvent('netværk besøg', null, null, group);
            visited.push(group.id);
            document.cookie = 'networksvisited=' + JSON.stringify(visited) + ';path=/;SameSite=Strict';
        }
        logNetworkVisit(resultState.oidc.user.profile.Id, group.id);
        
        switchedToGroup = undefined;
    }

    return result;
}

const readCookie = (): any => {
    const cookieElements = document.cookie.split(';');
    let o: any = {};
    cookieElements.forEach(ce => {
        //console.log(ce);
        const parts = ce.split('=');
        if (parts.length === 2) {
            o[parts[0].trim()] = parts[1].trim();
        }        
    });
    return o;
}

export default groupChangeLoggingMiddleware;